import { render, staticRenderFns } from "./ProveedorDatosFiscalesFormulario.vue?vue&type=template&id=56dba750&"
import script from "./ProveedorDatosFiscalesFormulario.vue?vue&type=script&lang=js&"
export * from "./ProveedorDatosFiscalesFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports